// extracted by mini-css-extract-plugin
export var auctions = "live-auctions--auctions--3xYuJ";
export var auctions__wrapper = "live-auctions--auctions__wrapper--2INks";